import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface UserAdmin {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  department?: string | null;
  avatarUrl?: string | null;
  roles: string[];
  emailConfirmed: boolean;
  lockoutEnd?: string | null;
  created: string;
  lastModified: string;
}

export interface UpdateUserRequest {
  /** Vários papéis; quando presente ganha ao `role`. */
  roles?: string[];
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  department?: string | null;
  role: string;
  isActive?: boolean;
  newPassword?: string;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export function getUsers(): Promise<UserAdmin[]> {
  return request<UserAdmin[]>("/api/users");
}

export function getUserById(userId: string): Promise<UserAdmin> {
  return request<UserAdmin>(`/api/users/${userId}`);
}

export function updateUser(
  userId: string,
  payload: UpdateUserRequest,
): Promise<UserAdmin> {
  return request<UserAdmin>(`/api/users/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
